import {
  Component,
  EventEmitter,
  HostListener,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import {AnnouncementModalComponent} from "../../pages/announcement/user/announcement-modal/announcement.component";
import {
  SidebarAnnouncementCanvasComponent
} from "../../pages/announcement/user/sidebar-announcement/sidebar-announcement.component";
import {CallViewPopupComponent} from "../../shared/components/call-card-view-popup/call-card-view-popup.component";
import {
  SidebarLastCallsCanvasComponent
} from "../../pages/announcement/user/sidebar-last-calls/sidebar-last-calls.component";


@Component({
  selector: 'app-core-messages-canvas',
  templateUrl: './sidebar-message.component.html',
  styleUrl: './sidebar-message.component.scss',
})
export class SidebarMessageCanvasComponent implements OnChanges {

  @ViewChild('announcementReadModal')
  announcementModal: AnnouncementModalComponent;
  @ViewChild('announcementCanvas')
  announcementCanvas: SidebarAnnouncementCanvasComponent;
  @ViewChild('callViewPopupComponent')
  callViewPopupComponent: CallViewPopupComponent;
  @ViewChild('sidebarLastCallsCanvasComponent')
  sidebarLastCallsCanvasComponent: SidebarLastCallsCanvasComponent;

  @Output() onSaveEmitter = new EventEmitter();
  @Output() closed = new EventEmitter();
  @Output() onChoose = new EventEmitter();
  @Input() position: 'left' | 'right' | 'top' | 'bottom' = 'right';
  @Input() width: string = '20%';
  isOpen: boolean = false;
  isOpenCall: boolean = false;

  items: any[] = [];

  totalRecords = 0;

  constructor() {
    this.onChoose.emit();
  }


  openPopup() {
    this.isOpen = true;
  }

  openAnnouncement(event: any) {
    this.announcementModal.openDialog(event);
  }
  openAnnouncementArray(event: any) {
    this.announcementModal.startAnnouncementFlow(event);
  }

  openCallCard(event: any) {
    this.callViewPopupComponent.openDialog(event);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['width'] && changes['width']?.firstChange == false) {
      this.width = changes['width']?.currentValue;
      this.isOpen = false;
      setTimeout(() => {
        this.isOpen = true;
      }, 200);
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    if (event.target.innerWidth <= 480) {
      this.width = '90vw';
    }
  }

  closePopup() {
    this.isOpen = false;
    this.closed.emit();
  }

  save() {
    this.onChoose.emit();
    this.announcementCanvas.loadData({}, {});
  }
}
